<template>
  <v-container
    fluid
  >

    <v-tabs fixed-tabs  hide-slider v-model="activeTab" >
      <v-tab key="tab-1" :to="{ name: 'ProjectShow', params: { 'id': id }}">
        {{$t('projects.submenu.projectDetails')}}
      </v-tab>
      <v-tab key="tab-2" :to="{ name: 'ProjectBarrierChecklist', params: { 'id': id }}">
        {{$t('projects.submenu.barrierChecklist')}}
      </v-tab>
      <v-tab  key="tab-3" :to="{ name: 'ProjectRiskAnalysisSummary', params: { 'id': id }}">
        {{$t('projects.submenu.riskAnalysis')}}
      </v-tab>


    </v-tabs>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-container class="pa-0"  fluid>
              <v-row justify="center">

                <v-col>
                  <a @click="backToProject">     {{$t("projects.submenu.backToProject")}}</a>
                  <v-card-text>

                    <h2 class="font-weight-light mb-4">
                      {{projectName}}
                    </h2>
                  </v-card-text>
                </v-col>
              </v-row>



                <v-row>

                   <v-col cols="12" md="6">
                      <v-select
                        v-model="selectedWorkTypes"
                        :items="workTypes"
                        chips
                        multiple
                        clearable
                        :item-text="'name'"
                        :item-value="'id'"
                        :label="$t('potentialIncident.workType')"
                        @change="getWorkOperations"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        :disabled="selectedWorkTypes.length==[]"
                        v-model="selectedWorkOperations"
                        :items="workOperations"
                        chips
                        multiple
                        clearable
                        :item-text="'name'"
                        :item-value="'id'"
                        :label="$t('potentialIncident.workOperation')"

                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="selectedLocations"
                        :items="locations"
                        chips
                        multiple
                        clearable
                        :item-text="'name'"
                        :item-value="'id'"
                        :label="$t('potentialIncident.location')"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="selectedIncidentTypes"
                        :items="incidentTypes"
                        chips
                        multiple
                        :item-text="'name'"
                        :item-value="'id'"
                        :label="$t('potentialIncident.incidentType')"
                      ></v-select>
                    </v-col>

                  <v-col cols="24" md="12">
                    <v-select
                      v-model="selectedColumns"
                      :items="columns"
                      chips
                      multiple
                      clearable
                      :item-text="'name'"
                      :item-value="'id'"
                      :label="$t('projects.riskAnalysisSummary.columnsToShow')"
                    ></v-select>
                  </v-col>
                </v-row>
              <v-row>


              </v-row>
              <v-row>


                  <v-col cols="12" md="6">
                    <v-switch
                      v-model="includeBarriers"
                      :label="$t('projects.riskAnalysisSummary.includeBarriers')"
                    ></v-switch>
                    <v-select
                      v-model="selectedBarrierColumns"
                      :items="barrierColumns"
                      :disabled="!includeBarriers"
                      chips
                      multiple
                      clearable
                      :item-text="'name'"
                      :item-value="'id'"
                      :label="$t('projects.riskAnalysisSummary.barrierColumnsToShow')"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-switch
                      v-model="includeMeasures"
                      :label="$t('projects.riskAnalysisSummary.includeMeasures')"
                    ></v-switch>
                    <v-select
                      v-model="selectedMeasureColumns"
                      :items="measureColumns"
                      :disabled="!includeMeasures"
                      chips
                      multiple
                      clearable
                      :item-text="'name'"
                      :item-value="'id'"
                      :label="$t('projects.riskAnalysisSummary.measureColumnsToShow')"
                    ></v-select>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col>

                    <v-btn :loading="loading"  @click="showRiskAnalysisSummary">
                      {{$t("projects.riskAnalysisSummary.showSummary")}}
                    </v-btn>



                  </v-col>
                </v-row>

            </v-container>

          </v-card-text>
        </v-card>
      </v-col></v-row>

  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import languageUtil from '../utils/language'
    import riskUtil from '../utils/riskutil'
    import jsPDF from 'jspdf'
    import jsPDFautotable from 'jspdf-autotable';


    export default {
        data() {
            return {
                id:"",
                projectName:"",
                potentialIncidents: [],
                potentialIncidentsFiltered: [],
                locations: [],
                incidentTypes: [],
                probabilityLevels: [],
                consequenceStrengths: [],
                workTypes:[],
                selectedWorkTypes:[],
                selectedWorkOperations:[],
                selectedIncidentTypes:[],
                selectedLocations:[],
                workOperations:[],
                selectedColumns:["logicalId", "workType", "workOperation", "location", "incidentType", "explanation", "consequenceType", "consequence", "probability", "risk", "consequenceAfterMeasures", "probabilityAfterMeasures", "riskAfterMeasures"],
                columns:[],
                includeBarriers:false,
                selectedBarrierColumns:["barrierDescription", "barrierType", "barrierOwner", "barrierComment", "barrierStrong"],
                barrierColumns:[],
                includeMeasures:false,
                selectedMeasureColumns:["measure", "measureResponsible", "measureStatus", "dateClosed", "commentOnClosed"],
                measureColumns:[],
                activeTab:2,
                loading:false


            }
        },
        methods: {
          selectDefaultColumnsForCustomer() {
            if (this.currentCustomerLogicalId==="omexom_norge" || this.currentCustomerLogicalId==="omexom_norge_en" || this.currentCustomerLogicalId==="omexom_sverige") {
                 this.selectedColumns=["logicalId", "workType", "workOperation", "incidentType", "explanation",  "consequence", "probability", "risk",  "riskAfterMeasures"]
                this.selectedBarrierColumns=["barrierDescription"]
                this.includeBarriers = true

            }


          },

            getProject(projectid) {
                api.getProject(projectid).then(response => {
                    this.id = response.id
                    this.projectName= response.name

                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getProbabilityLevels () {
                api.getProbabilityLevels().then(response => {
                    this.probabilityLevels= response.map(function(strength) { return {'id':strength.strength, 'name':strength.name + ' (' + strength.strength + ')'}})
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getConsequenceStrengths() {
                api.getConsequenceStrengths().then(response => {
                    this.consequenceStrengths= response.map(function(strength) { return {'id':strength.strength, 'name':strength.name + ' (' + strength.strength + ')'}})
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getWorkOperations() {

                var operationsFiltered = this.potentialIncidents.filter(ele=>{ return this.selectedWorkTypes.includes(ele.workType.id)})

                this.workOperations =operationsFiltered.map(ele =>ele.workOperation)
                this.selectedWorkOperations = this.selectedWorkOperations.filter(ele=>{return this.workOperations.map(ele2=>ele2.id).includes(ele)})

            },

            showRiskAnalysisSummary() {
              this.loading = true
                var selectedBarriers = []
                if (this.includeBarriers)
                    selectedBarriers = this.selectedBarrierColumns

                var selectedMeasures=[]
                if (this.includeMeasures)
                    selectedMeasures = this.selectedMeasureColumns
                ''
                api.downloadRiskAnalysis(this.id, this.selectedWorkTypes, this.selectedWorkOperations, this.selectedLocations, this.selectedIncidentTypes, this.selectedColumns, selectedBarriers, selectedMeasures, this.setLoadingToFalse)

            },
          setLoadingToFalse() {
            this.loading = false;
          },
            backToProject() {
                this.$router.push({path: '/projectShow/' + this.id});
            },
            getPotentialIncidents(projectid) {
                api.getPotentialIncidents(projectid).then(response => {
                    this.potentialIncidents = response
                    this.potentialIncidentsFiltered = this.potentialIncidents
                    this.workTypes = this.potentialIncidents.map(ele =>ele.workType)
                    this.locations = this.potentialIncidents.map(ele=>ele.location).filter(ele=>ele.name!='')
                    this.incidentTypes = this.potentialIncidents.map(ele=>ele.incidentType).filter(ele=>ele.name!='')

                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            setColumns() {
                this.columns = [
                    {'name':this.$i18n.t('potentialIncident.logicalId'), 'id':"logicalId"},
                    {'name':this.$i18n.t('potentialIncident.workType'), 'id':"workType"},
                    {'name':this.$i18n.t('potentialIncident.workOperation'), 'id':"workOperation"},
                    {'name':this.$i18n.t('potentialIncident.location'), 'id':"location"},
                    {'name':this.$i18n.t('potentialIncident.incidentType'), 'id':"incidentType"},
                    {'name':this.$i18n.t('potentialIncident.explanation'), 'id':"explanation"},
                    {'name':this.$i18n.t('potentialIncident.consequenceType'), 'id':"consequenceType"},
                    {'name':this.$i18n.t('potentialIncident.consequence'), 'id':"consequence"},
                    {'name':this.$i18n.t('potentialIncident.probability'), 'id':"probability"},
                    {'name':this.$i18n.t('potentialIncident.risk'), 'id':"risk"},
                    {'name':this.$i18n.t('potentialIncident.consequenceAfterMeasures'), 'id':"consequenceAfterMeasures"},
                    {'name':this.$i18n.t('potentialIncident.probabilityAfterMeasures'), 'id':"probabilityAfterMeasures"},
                    {'name':this.$i18n.t('potentialIncident.riskAfterMeasures'), 'id':"riskAfterMeasures"},


                ]
                this.barrierColumns = [
                    {'name': this.$i18n.t('barrier.description'), 'id':"barrierDescription"},
                    {'name': this.$i18n.t('barrier.type'), 'id':"barrierType"},
                    {'name': this.$i18n.t('barrier.owner'), 'id':"barrierOwner"},
                    {'name': this.$i18n.t('barrier.comment'), 'id':"barrierComment"},
                    {'name': this.$i18n.t('barrier.strong'), 'id':"barrierStrong"}

                ]
                this.measureColumns = [
                    {'name':this.$i18n.t('measure.measure'), 'id':"measure"},
                    {'name':this.$i18n.t('measure.measureResponsible'), 'id':"measureResponsible"},
                    {'name':this.$i18n.t('measure.status'), 'id':"measureStatus"},
                    {'name':this.$i18n.t('measure.dateClosed') , 'id':"dateClosed"},
                    {'name':this.$i18n.t('measure.commentOnClosed') , 'id':"commentOnClosed"}

                ]
            }
        },

        mounted() {
            this.getProject(this.$route.params.id)
            this.getPotentialIncidents(this.$route.params.id)
            this.getConsequenceStrengths()
            this.getProbabilityLevels()
            this.setColumns()
           this.selectDefaultColumnsForCustomer()
        }
    }
</script>
